import { useTranslation } from 'react-i18next';

export default function WhatYouGet() {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6 px-4">
            {t('whatYouGet.title')}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto px-4">
            {t('whatYouGet.description')}
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 md:p-10 max-w-3xl mx-auto">
          <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.companyName.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.companyName.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.vatNumber.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.vatNumber.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.phoneNumber.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.phoneNumber.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.fullAddress.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.fullAddress.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.postalCode.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.postalCode.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.website.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.website.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.reviews.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.reviews.description')}</p>
              </div>
            </div>

            <div className="flex items-start gap-3 sm:gap-4">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-check-line text-white text-base sm:text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-slate-900 text-base sm:text-lg mb-1">{t('whatYouGet.fields.openingHours.title')}</h3>
                <p className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.fields.openingHours.description')}</p>
              </div>
            </div>
          </div>

          <div className="mt-8 sm:mt-10 pt-6 sm:pt-8 border-t border-slate-200">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8 text-center">
              <div>
                <div className="text-2xl sm:text-3xl font-bold text-teal-600 mb-2">{t('whatYouGet.stats.allBelgium')}</div>
                <div className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.stats.coverage')}</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
              <div>
                <div className="text-2xl sm:text-3xl font-bold text-teal-600 mb-2">{t('whatYouGet.stats.allSectors')}</div>
                <div className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.stats.filterTarget')}</div>
              </div>
              <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
              <div>
                <div className="text-2xl sm:text-3xl font-bold text-teal-600 mb-2">{t('whatYouGet.stats.languages')}</div>
                <div className="text-slate-600 text-xs sm:text-sm">{t('whatYouGet.stats.bothLanguages')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
